import { NavLink, useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { useGesture } from "@use-gesture/react";

const tabOrder = ["/", "/read", "/book-a-call"];

const Tabs = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const currentIndex = tabOrder.indexOf(location.pathname);
  const goToTab = (i: number) => {
    if (i >= 0 && i < tabOrder.length) {
      navigate(tabOrder[i]);
    }
  };

  const bind = useGesture({
    onDragEnd: ({ swipe: [swipeX] }) => {
      if (swipeX === -1) goToTab(currentIndex + 1);
      if (swipeX === 1) goToTab(currentIndex - 1);
    },
  });

  return (
    <Wrapper $isMap={location.pathname === "/"}>
      <TabBar {...bind()} className="z-depth-3">
        {tabOrder.map((path, i) => (
          <NavLink
            key={path}
            to={path}
            className={({ isActive }) => (isActive ? "active" : "")}
          >
            {path === "/" ? "Map" : path === "/read" ? "Read" : "Book a Call"}
          </NavLink>
        ))}
      </TabBar>
    </Wrapper>
  );
};

export default Tabs;

const Wrapper = styled.div<{ $isMap: boolean }>`
  display: flex;
  justify-content: center;
  position: fixed;
  width: 100%;
  bottom: 0;
  margin-bottom: 20px;

  @media only screen and (max-width: 650px) {
    position: ${({ $isMap }) => ($isMap ? "unset" : "fixed")};
  }
`;

const TabBar = styled.div`
  position: absolute;
  bottom: 0;
  display: flex;
  justify-content: center;
  padding: 5px;
  background: white;
  z-index: 100;
  touch-action: pan-y;
  border-radius: 30px;

  a {
    text-decoration: none;
    font-weight: 500;
    font-size: 16px;
    color: #666;
    transition: color 0.2s;
    padding: 8px 20px;
  }

  .active {
    color: white;
    background: black;
    padding: 8px 20px;
    border-radius: 30px;
  }
`;
